import { ConvertBoxDataType } from '../convertBox.index';

export enum __SellWithdrawMethodsEnums {
    wallet = 0,
    iBan,
}

export interface __SellWithdrawMethodConvertBoxProps {
    onSubmit: (e: ConvertBoxDataType) => void;
    onBack: () => void;
    data?: ConvertBoxDataType;
}
